module.exports = __webpack_public_path__ + "img/service-5.5411f0ed.jpg";